import React from 'react';
import { Grid } from '@material-ui/core';
import { LawSettingsList } from './List';
import { LawSettingsForm } from './Form';
import { useLawSettingsState, canDelete } from './State';
import { Panel } from '../../../../../Components/Panel/Panel';
import { useIntl } from 'react-intl';
import Loading from '../../../../../Components/Loading';
import { DeleteDescription } from './DeleteDescription';

export const LawSettingsAreas = () => {
  const { formatMessage } = useIntl();
  const { items, submit, editItem, loading, removeItem, editing, cancelEdit } = useLawSettingsState('areas', {
    canDelete,
    getDeleteDescription: (item, canDelete) => (
      <DeleteDescription item={item} typeTranslationKey="admin.law-portal.settings.area" canDelete={canDelete} />
    ),
  });

  return (
    <Panel titleKey="admin.law-portal.settings.areas" accordion>
      {(loading && <Loading />) || (
        <Grid container spacing={3}>
          <Grid item md={4} xs={12}>
            <LawSettingsForm
              id="admin.law-portal.settings.area"
              submit={submit}
              edit={editing}
              cancelEdit={cancelEdit}
            />
          </Grid>
          <Grid item md={8} xs={12}>
            <LawSettingsList
              type={formatMessage({ id: 'admin.law-portal.settings.areas' })}
              items={items}
              deleteItem={removeItem}
              onEditItem={editItem}
            />
          </Grid>
        </Grid>
      )}
    </Panel>
  );
};
